export default "__VITE_ASSET__CtIxdHAP__"